import React from 'react'
import { browserHistory } from 'react-router'
import cookie from 'react-cookie'
import CSSModules from 'react-css-modules'
import styles from './logoLink.css'
import { api, host, domen } from '../../config.js'

const LogoLink = ({isTest, isAlfa, isTele2Lk}) => {
  if(domen.isUnipro || domen.isEls){
    return(<div>
      <img className={styles.uniproLogoMobile}
           src="/assets/img/els/logo.svg" alt=""
           onClick={() => {
             cookie.remove('token', {path: '/'})
             cookie.remove('txId', {path: '/'})
             cookie.remove('role', {path: '/'})
             cookie.remove('program', {path: '/'})
             cookie.remove('packageType', {path: '/'})
             cookie.remove('promoName', {path: '/'})
             cookie.remove('share', {path: '/'})
             //cookie.remove('general', { path: '/' })
             cookie.remove('userProgram', {path: '/'})
             cookie.remove('tester', {path: '/'})
             cookie.remove('abtest', {path: '/'})
             browserHistory.push('/')
           }}
      />
      <img className={styles.uniproLogo}
           src="/assets/img/els/logo.svg" alt=""
           onClick={() => {
             cookie.remove('token', {path: '/'})
             cookie.remove('txId', {path: '/'})
             cookie.remove('role', {path: '/'})
             cookie.remove('program', {path: '/'})
             cookie.remove('packageType', {path: '/'})
             cookie.remove('promoName', {path: '/'})
             cookie.remove('share', {path: '/'})
             //cookie.remove('general', { path: '/' })
             cookie.remove('userProgram', {path: '/'})
             cookie.remove('tester', {path: '/'})
             cookie.remove('abtest', {path: '/'})
             browserHistory.push('/')
           }}
      />
    </div>)
  }
}
export default CSSModules(LogoLink, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/componentKit/LogoLink.js